const KEY = "__used_sesids_v1";

function readUsed() {
    try {
        const raw = JSON.parse(sessionStorage.getItem(KEY)) || [];
        const now = Date.now();
        const TTL = 30 * 60 * 1000;
        return new Map(raw.filter(([id, ts]) => now - ts < TTL));
    } catch {
        return new Map();
    }
}

function writeUsed(map) {
    const cap = 100;
    const arr = Array.from(map.entries()).slice(-cap);
    sessionStorage.setItem(KEY, JSON.stringify(arr));
}

function randUUID() {
    return crypto.randomUUID();
}

export function generateSesid(hint = "") {
    const used = readUsed();
    let id;
    for (let i = 0; i < 5; i++) {
        const ts = Date.now().toString(36);
        const uuid = randUUID().replace(/-/g, "");
        const h = hint ? String(hint).slice(-6) : "";
        id = ["s", ts, uuid, h].filter(Boolean).join("-");
        if (!used.has(id)) break;
    }
    used.set(id, Date.now());
    writeUsed(used);
    return id;
}
